module.exports = __webpack_public_path__ + "static/dervyandom-f853059899a4e931c158201edb4de5b1.jpg";